function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { FormStateWrapper } from "./FormStateWrapper";
import { FormWrapper } from "./FormWrapper";
export var Form = function(param) {
    var children = param.children, initialValues = param.initialValues, name = param.name, onFinish = param.onFinish;
    return /*#__PURE__*/ _jsx(FormStateWrapper, {
        initialValues: _object_spread({}, initialValues),
        children: /*#__PURE__*/ _jsx(FormWrapper, {
            initialValues: initialValues,
            name: name,
            onFinish: onFinish,
            root: true,
            children: children
        })
    });
};

//# sourceMappingURL=Form.js.map